import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiCheck } from 'react-icons/fi';

const DiscoverItem = ({ title, content, list }) => (
  <div className="py-10 border-b border-slate-100 last:border-0">
    <h3 className="text-2xl font-display font-black text-brand-dark mb-4 flex items-center gap-4">
      <span className="text-brand-gold text-3xl">✔</span>
      {title}
    </h3>
    <div className="pl-10 space-y-4 text-xl">
      <p className="text-text-secondary">{content}</p>
      {list && (
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-4">
          {list.map((item, i) => (
            <li key={i} className="flex items-center gap-3 text-sm font-bold uppercase tracking-widest text-brand-dark">
              <span className="w-1.5 h-1.5 bg-brand-green rounded-full"></span>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

const DiscoverLetter = () => {
  return (
    <SalesLetterWrapper>
      <h2 className="text-3xl md:text-5xl font-display font-black text-brand-dark mb-16 text-center">
        Inside “Simple Online Income For Retirees,” You’ll Discover:
      </h2>

      <div className="space-y-4">
        <DiscoverItem 
          title="The SAFE Framework™"
          content="A simple system for identifying online income opportunities that are: Simple, Affordable, Flexible, Easy-To-Start."
        />
        <DiscoverItem 
          title="How To Avoid Online Scams & Fake Gurus"
          content="Learn the biggest warning signs retirees must watch for online before wasting money, time, or confidence."
        />
        <DiscoverItem 
          title="Beginner-Friendly Online Income Methods"
          content="Discover practical low-risk income opportunities retirees can realistically explore online."
          list={['remote admin work', 'customer support', 'AI-assisted freelancing', 'printables & digital downloads', 'flexible contract work', 'portable online income ideas']}
        />
        <DiscoverItem 
          title="How To Use Simple AI Tools (Without Becoming “Technical”)"
          content="Learn beginner-friendly ways to use tools like ChatGPT and Canva to simplify online work."
        />
        <DiscoverItem 
          title="Portable Retirement Income Strategies"
          content="Discover how retirees are creating flexible online income while: travelling, caravanning, living regionally, or simply enjoying more lifestyle freedom."
        />
        <DiscoverItem 
          title="Your First 30-Day Action Plan"
          content="Know exactly: what to do first, how to avoid overwhelm, and how to build confidence step-by-step."
        />
      </div>
    </SalesLetterWrapper>
  );
};

export default DiscoverLetter;